import React, { useEffect, useState } from "react";
import Loading from "components/Shared/Loading/Loading";
import { audio } from "services/audioManager"
function flatten(obj) {
    if (!obj) return [];
    return Object.values(obj).flatMap(v => (typeof v === "string" ? [v] : flatten(v)));
}
export default function Preloader({ imagesToLoad, fontsToLoad, audioToLoad, onComplete }) {
    const [done, setDone] = useState(false);
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        let cancelled = false;
        const imgList = Array.isArray(imagesToLoad) ? imagesToLoad : [];
        const fontList = Array.isArray(fontsToLoad) ? fontsToLoad : [];
        const audioList = Array.isArray(audioToLoad) ? audioToLoad : [];
        const total = imgList.length + fontList.length + audioList.length;
        if (total === 0) { setDone(true); return; }
        const step = 100 / total;
        const bump = () => !cancelled && setProgress(progress => Math.min(100, progress + step));
        const loadImage = src =>
            new Promise(res => { const img = new Image(); img.onload = img.onerror = () => { bump(); res(); }; img.src = src; });
        const loadFont = font =>
            new Promise(res => {
                if (!window.FontFace) { bump(); res(); return; }
                const fontFace = new FontFace(font.font, `url(${font.path})`);
                fontFace.load().then(
                    () => { document.fonts.add(fontFace); bump(); res(); },
                    () => { bump(); res(); }
                );
            });
        const loadAudio = def =>
            new Promise(res => {
                audio.primeClip(def).then(() => { bump(); res(); }, () => { bump(); res(); });
            });
        Promise.all([...imgList.map(loadImage), ...fontList.map(loadFont), ...audioList.map(loadAudio)]).then(() => { if (!cancelled) onComplete(); setDone(true); });
        return () => { cancelled = true; };
    }, [imagesToLoad, fontsToLoad, audioToLoad, onComplete]);
    if (!done) return <Loading loadingText="" progress={progress} />;
    return null;
}
export { flatten };